"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var EventBindingDescriptionsListCtl = /** @class */ (function (_super) {
    __extends(EventBindingDescriptionsListCtl, _super);
    function EventBindingDescriptionsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_teaser_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.teaser_image_url; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_details = UIUtils_1.UIUtils.IProp2Str(function (o) { o.details; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingDescriptionsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    EventBindingDescriptionsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "event binding description with id [" + id + "] not found !";
    };
    EventBindingDescriptionsListCtl.prototype.LoadData = function (EventBindingId, onDone) {
        var _this = this;
        webAApi_1.ListBonusEventBindingsDescriptionsByBindingIdGet.exec({
            event_binding_id: EventBindingId,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    teaser_image_url: resp.list[i].teaser_image_url,
                    title: resp.list[i].title,
                    details: resp.list[i].details,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingDescriptionsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusEventBindingDescription.exec({
            data: {
                event_binding_id: data.event_binding_id,
                app_language_id: data.app_language_id,
                title: data.title,
                teaser_img_url: data.teaser_img_url,
                description: data.description,
                details: data.details
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                teaser_image_url: data.teaser_img_url,
                title: data.title,
                details: data.details,
                description: data.description,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_changed_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingDescriptionsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusEventBindingDescription.exec({
                data: {
                    event_binding_description_id: data.key,
                    app_language_id: data.app_language_id,
                    title: data.title,
                    teaser_img_url: data.teaser_img_url,
                    description: data.description,
                    details: data.details
                }
            }, function (resp) {
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.title = data.title;
                _tmp.teaser_image_url = data.teaser_img_url;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.details = data.details;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    EventBindingDescriptionsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    EventBindingDescriptionsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusEventBindingDescription.exec({ data: { event_binding_description_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return EventBindingDescriptionsListCtl;
}(BaseController_1.BaseController));
exports.EventBindingDescriptionsListCtl = EventBindingDescriptionsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/EventBindingDescriptionsListCtl.ts
// module id = 984
// module chunks = 0